import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'ServicoAnaliseTecNa'

const GetAllByWork = (data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)

export default {
  GetAllByWork,
  Create,
  Update
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/tecserviceanalysisna.js